import { Text } from '@shopify/polaris';
import { memo } from 'react';
type IAlignment = 'start' | 'center' | 'end' | 'justify';
type ITone = 'success' | 'critical' | 'caution' | 'subdued' | 'text-inverse';

const MediumText = ({ children, alignment, tone }: { children: React.ReactNode; alignment?: IAlignment; tone?: ITone }) => {
  return (
    <Text as="span" variant="bodyMd" alignment={alignment} tone={tone}>
      {children}
    </Text>
  );
};
export default memo(MediumText);
